import { z } from "zod";
import { localStore } from "../../../lib/store";

const FirstVisitFlagsSchema = z.object({
  seenDownloadAppModal: z.boolean(),
  hasVisitedProfilePage: z.boolean(),
  lemonCertifiedNotified: z.boolean(),
});

type FirstVisitFlags = z.infer<typeof FirstVisitFlagsSchema>;

const initialFirstVisitFlags: FirstVisitFlags = {
  seenDownloadAppModal: false,
  hasVisitedProfilePage: false,
  lemonCertifiedNotified: false,
};

export const firstVisitFlagsStore = localStore(
  "first-visit-flags",
  initialFirstVisitFlags,
  FirstVisitFlagsSchema
);

/**
 * Reset signup-scoped first-visit flags so a newly-onboarded user sees the
 * download-app modal and profile-picture prompt again. Does not touch the
 * lemon-certified toast flag, which is independent of onboarding.
 */
export function resetSignupFirstVisitFlags() {
  firstVisitFlagsStore.set((prev) => ({
    ...prev,
    seenDownloadAppModal: false,
    hasVisitedProfilePage: false,
  }));
}
